import { COW_CDN } from '@cowprotocol/common-const'

import ms from 'ms.macro'

export const PENDING_ORDER_PERMIT_CHECK_INTERVAL = ms`60s`

export const PRE_GENERATED_PERMIT_URL = `${COW_CDN}/token-lists/PermitInfo`
